class Change {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){

    $(".c-change-inner").attr('data-height', `${$(".c-change-inner").height()}px`);
    $('.c-change-inner__btn').click(function() {
      if($('.c-change-inner__btn').hasClass('is-active')) {
        $('.c-change-inner__btn').removeClass('is-active');
        $(this).html('<span></span>Read More');
        $(".c-change-inner").animate({
          'height': `${$(".c-change-inner").attr('data-height')}`,
        })
      } else {
        $('.c-change-inner__btn').addClass('is-active');
        $(this).html('<span></span>Close');
        $(".c-change-inner").animate({
          'height': `${$(".c-change-inner ul").height()}px`,
        })
      }
    })
  }
}